export const STATIC_BLOGS = [
  {
    id: "static-blog-luxury-villas-across-india",
    slug: "luxury-villas-across-india",
    title: "Luxury Villas Across India – Experience Royal Living with Homevilas",
    excerpt:
      "Discover handpicked luxury villas across India offering private pools, mountain views, beachfront serenity, and curated hospitality.",
    image_url:
      "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1600&q=80",
    published_at: "2026-02-11T00:00:00.000Z",
    body: `Luxury travel in India is no longer limited to hotel suites and palace stays. Private villas have become the most compelling way to experience the country: more intimate, more flexible, and far more personal. At Homevilas, our villa portfolio spans coasts, hills, heritage towns, and countryside escapes — each designed for privacy, comfort, and a slower way to travel.

## Why Luxury Villas Work Better

Luxury villas offer what traditional hospitality often cannot: space, privacy, and a home-like rhythm without compromising service. Whether you are traveling with family, as a couple, or with a group of friends, a private villa gives you access to your own living spaces, outdoor areas, and tailored experiences.

## Destinations That Shine

Goa delivers beachside villas, Kerala brings plantation serenity, Rajasthan offers heritage grandeur, and the hills of Himachal and Uttarakhand open into mountain-facing cottages and estates. Each region creates a very different mood, but the promise remains the same: trusted stays and curated support.

## The Homevilas Difference

Every Homevilas stay is selected with care. We focus on properties that are visually memorable, operationally reliable, and suited to the kind of trip guests actually want to take.

Browse Homevilas' collection of luxury villas across India for your next private stay.`,
  },
  {
    id: "static-blog-customized-travel-packages-homevilas",
    slug: "customized-travel-packages-homevilas",
    title: "Customized Travel Packages with Homevilas – Designed Just for You",
    excerpt:
      "Plan a holiday around your pace, preferences, and group style with curated villas, transport, sightseeing, and concierge support.",
    image_url:
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?w=1600&q=80",
    published_at: "2026-02-11T00:00:00.000Z",
    body: `No two trips should feel the same. Some travelers want a private villa and downtime, others want a tightly planned itinerary with local experiences, transport, meals, and guided moments. Homevilas customized travel packages are built around that idea: your holiday should adapt to you.

## What a Customized Package Includes

Depending on the destination and trip style, a Homevilas package can combine stays, airport transfers, local transport, sightseeing, experiences, meal planning, and concierge-led support. It is not about filling every hour — it is about making the journey feel coherent and personal.

## Better Than Fixed Itineraries

Fixed packages often miss the nuance of real travel. Families, couples, corporate groups, and multi-city travelers all need different pacing. Custom planning allows the itinerary to reflect arrival times, rest days, celebration moments, and practical comfort.

## Start with a Conversation

The best journeys usually begin with a short discussion about destination, travel dates, budget, and intent. From there, Homevilas can shape a package that feels both elevated and realistic.

If you want a curated holiday built around your travel style, start with a Homevilas custom package request.`,
  },
  {
    id: "static-blog-goa-luxury-villas-places-to-visit",
    slug: "goa-luxury-villas-places-to-visit",
    title: "Luxury Villas in Goa & Top Places to Visit",
    excerpt:
      "Explore premium Goa villas along with beaches, churches, markets, old quarters, and quieter inland corners worth planning around.",
    image_url:
      "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=1600&q=80",
    published_at: "2026-02-11T00:00:00.000Z",
    body: `Goa remains one of India's easiest luxury escapes, but the destination works best when the stay and the local plan complement each other. A private villa can give you calm and privacy, while the right mix of beaches, villages, markets, and heritage stops keeps the trip layered and memorable.

## Where Luxury Villas Work Best

North Goa is ideal if you want easy access to restaurants, nightlife, and a livelier social scene. Assagao, Vagator, and Siolim pair especially well with private villas. South Goa works better for slower holidays built around beaches, long lunches, and quieter evenings.

## Places Worth Adding to the Trip

Fontainhas for old-world character, Morjim and Ashwem for a calmer beach mood, Old Goa for church architecture, Chorao Island for a softer day out, and inland villages for cafés and boutique stores. Goa is strongest when you leave room for both beach time and exploration.

## Stay Private, Travel Wide

The advantage of a villa is that you can return to something personal after each outing — your own pool, your own lounge, your own rhythm. That balance is what makes Goa especially rewarding.

Explore Homevilas luxury villas in Goa and plan a more layered coastal escape.`,
  },
  {
    id: "static-blog-cab-rental-delhi-ncr-himachal-rajasthan-uttarakhand-up",
    slug: "cab-rental-delhi-ncr-himachal-rajasthan-uttarakhand-up",
    title: "Cab Rental from Delhi NCR to Himachal, Rajasthan, Uttarakhand & Uttar Pradesh",
    excerpt:
      "Comfortable intercity road travel from Delhi NCR to major North India leisure routes with curated vehicles and dependable support.",
    image_url:
      "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1600&q=80",
    published_at: "2026-02-11T00:00:00.000Z",
    body: `Road travel out of Delhi NCR still remains one of the most practical ways to reach North India's most popular leisure circuits. Whether the route is Jaipur, Manali, Rishikesh, Agra, Mussoorie, Shimla, or beyond, the quality of the car service shapes the trip more than most travelers expect.

## Why Private Cab Travel Still Matters

Intercity travel needs predictability: the right pickup time, a vehicle that matches the group size, a driver who knows the route, and a schedule that can adapt to real road conditions. That is especially important for families, older travelers, and airport-connected journeys.

## Popular Routes from Delhi NCR

Delhi to Jaipur, Agra, Rishikesh, Dehradun, Mussoorie, Nainital, Shimla, and Manali continue to be some of the most requested travel corridors. Each requires different timing, stop planning, and vehicle choices.

## Curated Ground Support

Homevilas approaches transport as part of the overall trip, not just a transfer. The goal is to make the road journey smoother, safer, and more aligned to the stay or holiday plan.

If your next North India trip starts in Delhi NCR, private cab travel remains one of the simplest ways to move well.`,
  },
  {
    id: "static-blog-coorg-plantation-cottages",
    slug: "coorg-plantation-cottages",
    title: "Coorg Coffee Plantation Cottages",
    excerpt:
      "Coorg is India's Scotland: misty estates, deep forests, estate-fresh coffee, and plantation cottages that slow everything down.",
    image_url:
      "https://images.unsplash.com/photo-1501854140801-50d01698950b?w=1600&q=80",
    published_at: "2026-03-20T00:00:00.000Z",
    body: `Coorg is India's Scotland — rolling hills perpetually wreathed in mist, dense forests of teak and rosewood, estates that produce some of the world's finest Arabica coffee, and a warrior people (the Kodavas) with a culture and cuisine entirely their own. The Cauvery river rises in these hills. Waterfalls tumble through cardamom groves. Elephants move through the Nagarhole forest just beyond the estate boundary. And in the middle of all this, a Homevilas plantation cottage awaits — with a fireplace, a hammock on the porch, and a cup of estate-fresh filter coffee that will change your relationship with the beverage forever.

## Life on a Working Estate

Homevilas' Coorg properties are mostly working plantations where coffee, pepper, cardamom, and areca nut grow in the same shade-forest system that has been maintained for generations. Staying here means waking at 5 AM to walk the estate with the estate manager while mist still clings to the pepper vines. It means watching coffee berries being sorted and graded on a sunlit veranda. It means understanding, viscerally, that your morning cup is the result of seasons of labour and extraordinary land.

## What Coorg Does to You

Coorg has a way of decompressing even the most wired of travellers. There are no all-night clubs, no neon strips, no agenda. You wake to birdsong, eat enormously, walk through the forest until your legs ache pleasantly, and sleep deeply in the cool hill air. Dubare Elephant Camp, Abbey Falls, Raja's Seat at sunset, and trekking to Tadiandamol all unfold without rush.

## The Kodava Table

Kodava cuisine is one of India's great undiscovered culinary traditions. Pandi curry, bamboo shoot curry, nool puttu, and kadambuttu are all prepared with the freshest ingredients from the estate garden and the nearby weekly market. Many Homevilas hosts in Coorg offer home-cooked meals and cooking demonstrations as part of the stay experience.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Coorg (Kodagu), Karnataka.`,
  },
  {
    id: "static-blog-goa-beach-villas",
    slug: "goa-beach-villas",
    title: "Goa's Best Private Beach Villas",
    excerpt:
      "From Assagao hideaways to South Goa slow stays, discover private villas that make Goa feel personal again.",
    image_url:
      "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?w=1600&q=80",
    published_at: "2026-03-21T00:00:00.000Z",
    body: `Goa is more than a destination — it's a feeling. The warm salt air, the amber sunsets over the Arabian Sea, the lazy rhythm of the shacks, and the lush quiet that falls over the hinterland once the day-trippers leave. When you stay in a private Homevilas villa in Goa, you don't just visit — you inhabit the place.

## Why a Private Villa Over a Hotel?

Goa's hotel strip can feel relentless in peak season. A private villa rewrites that experience entirely. You have your own cook, your own pool, and your own entrance. Families can spread across bedrooms without the formality of a hotel corridor. Couples can stay in a 1-BHK garden villa tucked behind bougainvillea in Assagao and feel like the village is theirs.

## Where to Stay in Goa

North Goa offers the energy — Anjuna, Vagator, Morjim, and Baga are all within reach of Homevilas-listed properties. South Goa slows everything down: Palolem, Agonda, and Canacona are for those who came to exhale. The hinterland villages of Assagao and Siolim are for the ones who want colonial charm, art cafés, and wine bars within walking distance of a private villa with a chef.

## What to Do

Take a sunrise walk on Morjim beach before the crowds arrive. Book a private boat to the backwaters of Chorao Island. Rent a scooter and find the Old Goa churches at golden hour. Goa rewards the unhurried, especially when you have a private villa to return to.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Goa.`,
  },
  {
    id: "static-blog-kerala-backwater-villas",
    slug: "kerala-backwater-villas",
    title: "Kerala Backwater Villas & Plantation Retreats",
    excerpt:
      "Backwaters, tea estates, and family-run heritage homes make Kerala one of the richest slow-travel destinations in India.",
    image_url:
      "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?w=1600&q=80",
    published_at: "2026-03-22T00:00:00.000Z",
    body: `Kerala is a study in green — from the deep emerald of the tea estates at Munnar to the shimmering jade of the backwater palms at Alleppey. It is also a study in water, slow rhythm, and deeply rooted hospitality.

## Alleppey: The Venice of the East

Homevilas' Alleppey listings range from private lake-facing villas with infinity pools to heritage homestays run by old Keralite families in traditional nalukettu courtyard houses. Wake up to a houseboat drifting past your balcony and let the rhythms of backwater Kerala slow your pulse.

## Munnar: Tea, Mist & Mountain Air

At 1,600 metres in the Western Ghats, Munnar is carpeted in some of the world's most picturesque tea estates. Homevilas properties here include planter's bungalows, private cottages amid spice gardens, and eco-lodges at the forest edge.

## The Cuisine That Stays With You

Kerala cooking is an education: sadya, fish molee, appam with stew, and prawn curry with kudampuli. Many Homevilas hosts offer cooking sessions, making the food itself part of the trip.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Kerala.`,
  },
  {
    id: "static-blog-lonavala-weekend-villas",
    slug: "lonavala-weekend-villas",
    title: "Lonavala & Mahabaleshwar Weekend Villas",
    excerpt:
      "A quick escape from Mumbai or Pune, with valley-view villas, monsoon drama, and private group stays in the Sahyadris.",
    image_url:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&q=80",
    published_at: "2026-03-23T00:00:00.000Z",
    body: `Three hours from Mumbai, two from Pune — and a world apart. The Western Ghats between the Konkan coast and the Deccan Plateau remain one of India's great weekend escape landscapes.

## Villas with Valley Views

Homevilas properties in the Lonavala–Khandala belt are typically large villas perched on hillsides with glass fronts that frame the Sahyadri gorges. These are built for groups who want space, privacy, and a barbecue terrace stretching into the valley.

## Mahabaleshwar: Strawberries and Sahyadri Skylines

Mahabaleshwar offers extraordinary viewpoints, strawberry farms, and Victorian-era charm. Homevilas estates around Mahabaleshwar and Panchgani include colonial bungalows on farms, private hilltop villas, and family retreats with large gardens.

## The Monsoon Magic

June to September transforms the Western Ghats beyond recognition. Waterfalls appear overnight, the valleys fill with cloud, and every hillside turns electric green. These villas are at their most dramatic in the rain.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Lonavala and Mahabaleshwar, Maharashtra.`,
  },
  {
    id: "static-blog-manali-mountain-homestays",
    slug: "manali-mountain-homestays",
    title: "Manali Mountain Homestays & Cottages",
    excerpt:
      "Manali works best from a timber-framed homestay, with mountain silence, orchard mornings, and local Himachali hospitality.",
    image_url:
      "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600&q=80",
    published_at: "2026-03-24T00:00:00.000Z",
    body: `There's a particular kind of silence that exists only at altitude — vast, textured, and alive in a way that city silence never quite manages. Manali offers it in abundance.

## The Homestay Difference in Manali

Traditional Manali homestays are architectural wonders in themselves — stone and deodar wood, slate roofs, and balconies overlooking snow peaks. Homevilas-listed properties range from cosy cottages in Old Manali to larger mountain retreats near Solang Valley.

## Adventures at Every Turn

Summer brings trekking, paragliding, river rafting, and road trips toward Spiti. Winter turns the valley into a snow globe, with skiing, snowmobile rides, frozen waterfalls, and evenings around a bukhari.

## Eating & Living Local

Sidu, trout from the Beas, Dham, and excellent Tibetan momos all make Manali richer than a simple hill-station escape. Many Homevilas stays include warm, home-cooked Himachali meals.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Manali, Himachal Pradesh.`,
  },
  {
    id: "static-blog-ooty-nilgiris-retreats",
    slug: "ooty-nilgiris-retreats",
    title: "Ooty & The Nilgiris: Tea Gardens and Mist-Clad Bungalows",
    excerpt:
      "Planter bungalows, Nilgiri tea country, and quieter stays around Ooty and Coonoor for a slower mountain holiday.",
    image_url:
      "https://images.unsplash.com/photo-1603193734000-a7b9bcc99028?w=1600&q=80",
    published_at: "2026-03-25T00:00:00.000Z",
    body: `Ooty was the Raj's great escape from the plains, and the tea country around it still holds that old-world charm. A Homevilas stay here is about more than a hill station — it is about the Nilgiris at their gentlest and most atmospheric.

## Bungalows in the Tea Belt

The tea estates between Ooty and Coonoor are dotted with century-old planters' bungalows, many with fireplaces, wide verandas, and views over the estate. Homevilas lists working estate homes where tea is still part of daily life.

## Coonoor: The Quieter Nilgiris

Coonoor retains a quieter colonial charm, with heritage cottages, old cafés, Sim's Park, and hill views that feel more intimate than Ooty's busier centre.

## The Blue Mountains by Rail

The Nilgiri Mountain Railway from Mettupalayam to Ooty remains one of India's greatest rail journeys. Arriving this way sets the tone for the entire stay.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Ooty and the Nilgiris, Tamil Nadu.`,
  },
  {
    id: "static-blog-rajasthan-heritage-havelis",
    slug: "rajasthan-heritage-havelis",
    title: "Rajasthan Heritage Havelis & Desert Villas",
    excerpt:
      "Jaipur courtyards, Udaipur lake homes, and Jaisalmer desert stays make Rajasthan one of Homevilas' most cinematic regions.",
    image_url:
      "https://images.unsplash.com/photo-1477587458883-47145ed6979e?w=1600&q=80",
    published_at: "2026-03-26T00:00:00.000Z",
    body: `Rajasthan is India at its most cinematic. Forts rise from the desert plains like mirages, and havelis preserve a culture of private hospitality that hotels rarely replicate.

## Jaipur: The Pink City's Hidden Courtyards

Homevilas' Jaipur listings include family havelis with rooftop terraces, Civil Lines garden bungalows, and stays close to the old bazaars where the city still feels lived-in rather than staged.

## Udaipur: The City of Lakes

Private stays in Udaipur elevate the city's romance — lakeside heritage homes, frescoed interiors, carved marble windows, and terraces looking out over the water at dusk.

## Jaisalmer: Sleeping Under the Desert Stars

In Jaisalmer, Homevilas stays range from fort suites to desert camps on the dunes, where silence, firelight, and the night sky become part of the stay itself.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Rajasthan.`,
  },
  {
    id: "static-blog-rishikesh-riverside-cottages",
    slug: "rishikesh-riverside-cottages",
    title: "Rishikesh Riverside Cottages & Yoga Retreats",
    excerpt:
      "Riverside cottages, yoga-led quiet stays, and high-energy adventure come together in a more balanced Rishikesh escape.",
    image_url:
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1600&q=80",
    published_at: "2026-03-27T00:00:00.000Z",
    body: `Rishikesh sits at the point where the Ganges descends from the Himalayan foothills onto the plains, and that transition gives the town its energy. It can be sacred, still, wild, and adrenaline-filled all at once.

## Private Stays Along the Holy River

Homevilas properties in Rishikesh range from quiet cottages near the ashram belt to larger riverside stays around Shivpuri and Byasi, where gardens, fire pits, and the sound of rapids shape the mood.

## Adventure Capital of India

White-water rafting, bungee jumping, mountain biking, rappelling, and forest drives make Rishikesh one of the country's most complete adventure destinations.

## The Quieter Rishikesh

Early-morning bridge walks, Ganga Aarti at dusk, rooftop yoga, and long Ayurvedic massages reveal the softer side of the town.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Rishikesh, Uttarakhand.`,
  },
  {
    id: "static-blog-shimla-hill-cottages",
    slug: "shimla-hill-cottages",
    title: "Shimla Colonial Cottages & Hill Retreats",
    excerpt:
      "Beyond the Mall Road, Shimla's quieter mountain belt opens into orchard cottages, cedar forests, and old colonial stays.",
    image_url:
      "https://images.unsplash.com/photo-1548013146-72479768bada?w=1600&q=80",
    published_at: "2026-03-28T00:00:00.000Z",
    body: `Shimla was the summer capital of British India, and the buildings that line its ridge still carry that slightly faded grandeur. But the best Homevilas stays are often just beyond the obvious centre.

## The Shimla That Doesn't Make the Postcards

Mashobra, Narkanda, Kufri, and Chail offer a quieter version of Shimla — with fireplaces, orchard views, and space to breathe far away from the Mall Road crowd.

## Winter Transforms Everything

In winter, snow settles on rooftops and cedar branches, ski slopes open, and the town takes on a different rhythm entirely. A colonial cottage after snowfall remains one of the most memorable mountain stays in India.

## The Apple Country Experience

September and October bring apple season, and many Homevilas stays sit close to orchard belts where picking, cider, and local produce become part of the trip.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Shimla, Himachal Pradesh.`,
  },
  {
    id: "static-blog-spiti-valley-himalayan-homestays",
    slug: "spiti-valley-himalayan-homestays",
    title: "Spiti Valley: Himalayan Homestays at the Top of the World",
    excerpt:
      "Remote village homestays, ancient monasteries, and zero-light-pollution skies make Spiti one of the most extraordinary Homevilas journeys.",
    image_url:
      "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=1600&q=80",
    published_at: "2026-03-29T00:00:00.000Z",
    body: `Spiti is the hardest destination in this collection to reach — and by far the most extraordinary. A cold desert valley between Tibet and the Indian Himalayas, accessible only for part of the year, and impossible to forget.

## Staying with Spitian Families

Homevilas works with families in Key, Kaza, Langza, Hikkim, and Tabo, where staying with locals still means eating with them, learning from them, and understanding the realities of life at altitude.

## The Ancient Monasteries

Ki, Dhankar, and Tabo are among the most extraordinary monastic sites in India. Their landscapes, murals, and daily routines shape the emotional core of any Spiti trip.

## The Night Sky and the Silence

Spiti has almost no light pollution. Nights here feel physical — stars crowd the sky, the Milky Way casts shape and depth, and silence becomes part of the memory.

Browse Homevilas' verified collection of private villas, plantation cottages, and luxury homestays in Spiti Valley, Himachal Pradesh.`,
  },
];

export const getStaticBlogBySlug = (slug) =>
  STATIC_BLOGS.find((blog) => blog.slug === slug) || null;
